<script>
  export let tags = {};
  $: kvs = Object.entries(tags).map(([k,v]) => ({ k, v }));
</script>

<table class='container'>
  {#each kvs as {k, v}, i}
  <tr title={k}>
    <td class='k'>{k}</td>
    <td class='v'>{v.replaceAll(' ', '-')}</td>
  </tr>
  {/each}
</table>

<style>
  .container {
    margin: 1.8rem 1rem;
  }
  .tag {
    width: 40rem;
    font-size: 1.2rem;
    line-height: 1.59rem;
    font-weight: 600;
    margin: 0.3rem;
    height: 1.6rem;
    border-radius: 4px;
    display: flex;
    align-content: center;
    justify-content: center;
    border: 1.5px solid hsl(223.4, 16.8%, 59%);
  }
  .k {
    color: #aeb6cb;
  }
  .v {
    padding: 0 0.4rem;
  }
  table {
    border-collapse: collapse;
  }
  td {
    padding: 0.4rem 0.5rem;
    border: 1px dotted #aeb6cb6a;
  }
  td:first-child, th:first-child {
   border-left: none;
  }
  td:last-child, th:last-child {
   border-right: none;
  }
  tr:first-child td {
   border-top: none;
  }
  tr:last-child td {
   border-bottom: none;
  }

  p {
    margin: 0;
  }
</style>
